import Vue from 'vue'
import App from './App.vue'
import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = process.env.NODE_ENV === 'production'

// Used to detect a click outisde for element
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.event = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.event)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.event)
  },
});

Vue.config.ignoredElements = [/^som-/]

new Vue({
  render: h => h(App),
}).$mount('#app')
